import { render, staticRenderFns } from "./collapseForm.vue?vue&type=template&id=80ff4b7a&scoped=true"
import script from "./collapseForm.vue?vue&type=script&lang=js"
export * from "./collapseForm.vue?vue&type=script&lang=js"
import style0 from "./collapseForm.vue?vue&type=style&index=0&id=80ff4b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ff4b7a",
  null
  
)

export default component.exports